import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Analytics, CustomParams, EventNameString, logEvent } from '@angular/fire/analytics';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private analitics = inject(Analytics, { optional: true });
  private location = inject(Location);
  private router = inject(Router);

  // constructor(
  //   @Optional() private analitics: Analytics,
  //   // @Inject(NB_WINDOW) private window: Window & { dataLayer: { event: string; path?: string; eventValue?: string }[] },
  //   private location: Location,
  //   private router: Router
  // ) {
  //   // this.enabled = this.window.location.href.indexOf('localhost') >= 0;
  // }

  public trackPageViews(customData?: CustomParams) {
    if (this.analitics) {
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        this.gtmPushToDataLayer({ event: 'page_view', page_path: this.location.path(), eventValue: customData });
      });
    }
  }

  public trackEvent(eventName: EventNameString | string, eventVal?: CustomParams) {
    if (this.analitics) {
      this.gtmPushToDataLayer({ event: eventName, eventValue: eventVal });
    }
  }

  private gtmPushToDataLayer(params: { event: string; page_path?: string; eventValue?: CustomParams }) {
    // this.window.dataLayer.push(params);
    if (this.analitics) {
      logEvent(this.analitics, params.event, {
        page_path: params.page_path,
        ...params.eventValue,
      });
    } else {
      console.warn('Analytics is not enabled');
    }
  }
}
